import { Notice } from '@mogzo/ui';
import { useLocation } from 'react-router';
import { Builds } from '../components/Builds';
import { useProject } from '../components/ProjectLayout';
import { Testers } from '../components/Testers';

/** The Overview tab (M25): the project's builds and testers. */
export function ProjectOverview() {
  const { project } = useProject();
  const location = useLocation();
  const justCreated = (location.state as { created?: boolean } | null)?.created === true;
  return (
    <>
      {justCreated && (
        <Notice tone="success" title={`${project.name} is ready`}>
          Its private test community is at mogzo.com/test/{project.slug}. Upload a build with{' '}
          <code className="mz-code">mogzo upload</code> to play it there.
        </Notice>
      )}
      <Builds project={project} />
      <Testers project={project} />
    </>
  );
}
